var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAccounts(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.0806 15.9232C22.1657 19.855 20.3578 21.4451 16.9596 21.1184C16.4151 21.0748 15.8269 20.9768 15.1952 20.8243L13.3655 20.3886C8.82379 19.3104 7.41881 17.0668 8.48616 12.5142L9.55352 7.9507C9.77134 7.02493 10.0327 6.21897 10.3595 5.5546C11.6338 2.91888 13.8012 2.21095 17.4389 3.07136L19.2577 3.49613C23.8212 4.56348 25.2153 6.81799 24.148 11.3706L23.0806 15.9232Z",
    stroke: "#9C9EA6",
    strokeWidth: 1.63371,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4001 22.2946L12.6793 22.861C8.35542 24.255 6.07913 23.0897 4.67414 18.7658L3.28005 14.4637C1.88595 10.1398 3.04044 7.85264 7.36431 6.45855L9.08515 5.8922C9.53169 5.75061 9.95646 5.63081 10.3594 5.55457C10.0327 6.21894 9.7713 7.0249 9.55348 7.95067L8.48612 12.5142C7.41877 17.0667 8.82375 19.3104 13.3655 20.3886L15.1952 20.8243C15.8269 20.9767 16.415 21.0748 16.9596 21.1183C16.2843 21.5758 15.4348 21.957 14.4001 22.2946Z",
    stroke: "#9C9EA6",
    strokeWidth: 1.63371,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.3237 9.29034L19.606 10.63",
    stroke: "#9C9EA6",
    strokeWidth: 1.63371,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2568 13.5053L16.4153 14.3113",
    stroke: "#9C9EA6",
    strokeWidth: 1.63371,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccounts);
export default __webpack_public_path__ + "static/media/accounts.0802aeb0.svg";
export { ForwardRef as ReactComponent };